import React, { Component } from 'react';
import { crudActions } from "@sm/services/crudActions";
import Form from "@sm/core/Form";

class PayoutTopUpComponent extends Component {
  payoutTopUpStatusValue = "PAYOUT_TOP_UP";
  state = {
    payoutTopUpGeneralFields: [[
      {
        name: "status",
        label: "Status",
        fieldType: "select",
        flexGrow: "5",
        disabled: true,
        getOptions: () => this.getOptionsFromState("statuses"),
        items: "statuses",
      },
      {
        name: "notes",
        label: "Notes",
        fieldType: "textarea",
        flexGrow: "10",
      }, { fieldType: "empty", flexGrow: "10" }
    ],
    [
      { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" },
      { fieldType: "button" },
    ]],
  };

  componentDidMount() {
    const { statuses } = this.props;
    if (statuses) {
      this.setState({
        statuses: statuses,
      });
    }
  }

  componentDidUpdate(oldProps) {
    const newProps = this.props;
    if (oldProps.statuses.length !== newProps.statuses.length) {
      this.setState({
        statuses: newProps.statuses,
      });
    }
  }

  onSaveDataEntries = () => {
    const { savedData, form } = this.props;

    form.forEach(elem => {
      elem.requestedBalance = elem.requestedBalance ? parseFloat(elem.requestedBalance).toFixed(2) : elem.requestedBalance;
      elem.incomingFunds = elem.requestedBalance;
    });
    form.forEach(elem => elem.fxRate = parseFloat("1").toFixed(2));
    form.forEach(elem => elem.fxPair = savedData.currency + "/" + savedData.currency);
    const formToSettle = form.filter(elem => elem.availableBalance > 0 || "status" in elem);
    const fieldsToCheck = ["requestedBalance"];

    formToSettle.forEach(row => {
      const shouldRequire = row.requestedBalance && row.account !== "All";

      row.fieldRules.forEach(fieldRule => {
        if (fieldsToCheck.includes(fieldRule.name)) {
          (fieldRule.rules ??= {}).required = shouldRequire;
        }
      });
    });
    const formToSettleRequested = form.filter(elem => (elem.requestedBalance && parseFloat(elem.requestedBalance) !== 0) || "status" in elem);
    const isValid = formToSettle.map((elem) => elem.isFormValid()).every(Boolean);
    this.saveValidationUpdate(form, isValid, isValid);
    if (isValid && (formToSettleRequested.length <= 1)) {
      this.errorUpdate('Nothing to Collect');
      return;
    }

    if (isValid) {
      const formState = form[form.length - 1];
      const incomingFunds = formToSettleRequested.filter(item => item.hasOwnProperty("account") && item.account !== "All").map((payoutTopUp) => ({
        accountId: payoutTopUp.accountId,
        disputedFunds: payoutTopUp.disputedFunds,
        availableBalance: payoutTopUp.availableBalance,
        requestedBalance: payoutTopUp.requestedBalance,
        incomingFundsAmount: payoutTopUp.incomingFunds,
        fxRate: payoutTopUp.fxRate,
      }));
      const data = {
        notes: formState.notes,
        status: formState.status,
        totalBalance: formToSettle[formToSettle.length - 2].availableBalance,
        currency: savedData.currency,
        fxPair: savedData.currency + "/" + savedData.currency,
        date: savedData.date,
        companyId: savedData.company,
        incomingFunds: incomingFunds
      };

      crudActions.post(`v1/incoming/funds`, data,)
        .then(() => {
          this.afterSuccessSave("Operation successful.");
        }).catch((err) => {
          this.errorUpdate(err ? err.message : '');
        });
    }
  };

  onChangeFilter = () => {
    const { controls } = this.props;
    
    const isFormValid = controls.isFormValid();
    this.onChangeValidationUpdate(controls, isFormValid);
    
    if (isFormValid) {
      crudActions.get(`v1/psp/accounts/balances?pspAccountIds=${controls.accountIds}&companyId=${controls.company}`).then((response) => {
        const filteredResponse = response.filter(elem => elem.balance > 0 || elem.disputedFunds > 0);
        if (!filteredResponse.length) {
          this.errorUpdate(" Well done! All balances are 0.00, there are no funds to collect.", "info");
          this.reset();
        } else {
          const newState =  this.populateOtcCashoutForm(filteredResponse);
          Object.assign(newState, {
            showSecondPanel: true,
            loadingDataInput: false,
            lockButton: false,
          });
          this.updateState(newState);
        }
      }).catch((error) => {
        this.reset();
        this.errorUpdate(error ? error.message : "");
      });
    }
  };

  reset = () => {
    const newState = {
      showSecondPanel: false,
      payoutTopUpForm: [],
    };
    this.updateField("PAYOUT_TOP_UP", []);
    this.updateState(newState);
  };

  populateOtcCashoutForm = (accounts) => {
    const { controls, companiesAccounts, companiesPsps } = this.props;
    const { payoutTopUpGeneralFields, statuses } = this.state;
    const stateForUpdate = { };
    const payoutTopUpForm = [];
    let PAYOUT_TOP_UP = [];
    accounts.forEach(account => {
      payoutTopUpForm.push(this.getAccountRowOtcCashoutForm(account, controls, companiesAccounts, companiesPsps));
    });

    payoutTopUpForm.sort((a, b) => {
      const lastLetterCompare = a.provider[0].localeCompare(b.provider[0]);
      if (lastLetterCompare !== 0) return lastLetterCompare;
      return a.account[0].localeCompare(b.account[0]);
    });

    payoutTopUpForm.forEach((account) => PAYOUT_TOP_UP.push(this.getOtcCashoutAccountRowFields(false, Number(account.availableBalance) <= 0)));

    if (payoutTopUpForm.length > 1) {
      payoutTopUpForm.push(this.getOtcCashoutFormTotal(controls, accounts));
    }

    if (payoutTopUpForm.length > 1) {
      PAYOUT_TOP_UP.push( this.getOtcCashoutAccountRowFields(true, true, true));
    }
    PAYOUT_TOP_UP.push([]);
    PAYOUT_TOP_UP = PAYOUT_TOP_UP.concat(payoutTopUpGeneralFields);
    this.updateField("PAYOUT_TOP_UP", PAYOUT_TOP_UP);

    const status = statuses.find(elem => elem.value === this.payoutTopUpStatusValue)?.value;
    const payoutTopUpFormState = new Form(
      {
        status: status || "",
        notes: "",
      },
      [
        {
          name: "status",
          type: "isString",
          rules: {
            required: true,
          }
        },
        {
          name: "notes",
          type: "isString"
        }
      ]
    );

    Object.assign(stateForUpdate,  {
      settlementMids: [...payoutTopUpForm]
    });
    payoutTopUpForm.push(new Form(), payoutTopUpFormState);
    Object.assign(stateForUpdate,  {
      payoutTopUpForm: payoutTopUpForm,
      payoutTopUpFormState: payoutTopUpFormState,
    });
    return stateForUpdate;
  };

  getOtcCashoutAccountRowFields = (commonLastRow, isFxRateFixed, requestedBalanceDisabled) => {
    return  [{
      name: "provider",
      label: commonLastRow ? "" : "Provider",
      fieldType: "input",
      disabled: true,
      flexGrow: "10"
    },{
      name: "account",
      label: commonLastRow ? "" : "Account",
      fieldType: "input",
      disabled: true,
      flexGrow: "10"
    }, {
      name: "disputedFunds",
      label: "Disputed Funds",
      fieldType: "input",
      formatValue: true,
      disabled: true,
      flexGrow: "8"
    },
    {
      name: "availableBalance",
      label: commonLastRow ? "Total Due Balance" : "Due Balance",
      fieldType: "input",
      formatValue: true,
      disabled: true,
      flexGrow: "8"
    },
    {
      name: "requestedBalance",
      label: "Top Up Amount",
      fieldType: "input",
      disabled: requestedBalanceDisabled,
      rightAlign: true,
      flexGrow: "8"
    },{
      name: "checkBox",
      fieldType: "checkBox",
      autoMethod: (index) => this.props.onAutoFunction(index, "availableBalance", "requestedBalance", "payoutTopUpForm"),
      alignSelf: "end",
      disabled: true,
      empty: commonLastRow,
      flexGrow: "0", 
    }];
    
  };

  getOtcCashoutFormTotal = (controls, accounts) => {
    return new Form(
      {
        provider: "All",
        account: "All",
        availableBalance: accounts.reduce((acc, item) => acc + parseFloat(item.balance), 0).toFixed(2),
        disputedFunds: accounts.reduce((acc, item) => acc + parseFloat(item.disputedFunds), 0).toFixed(2),
        requestedBalance: "",
      },
      [
        {
          name: "account",
          type: "isString",
          rules: {
            required: true
          },
        },
        {
          name: "totalAvailableBalance",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "requestedBalance",
          type: "isString",
          rules: {
            required: accounts.reduce((acc, item) => acc + parseFloat(item.balance).toFixed(2), 0) > 0,
          },
        }
      ]
    );
  };

  getAccountRowOtcCashoutForm = (account, controls, companiesAccounts, companiesPsps) => {
    const accountInfo = companiesAccounts[controls.company].find(item => item.value === Number(account.pspAccountId));
    return new Form(
      {
        provider: companiesPsps[controls.company].find(item => Number(item.value) === accountInfo.pspId).label,
        account: accountInfo.label,
        accountId: account.pspAccountId,
        disputedFunds: account.disputedFunds,
        availableBalance: parseFloat(account.balance).toFixed(2),
        requestedBalance: "",
        disabled: account.balance <= 0,
        isChecked: false
      },
      [
        {
          name: "account",
          type: "isString",
          rules: {
            required: true
          },
        },
        {
          name: "availableBalance",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "requestedBalance",
          type: "isString",
          rules: {
          },
        }
      ]
    );
  };

  getOptionsFromState = (optionsName) => {
    return this.state[optionsName];
  };

  updateField = (name, value) => {
    this.props.updateField(name, value);
  };

  updateState = (stateForUpdate) => {
    this.props.updateState(stateForUpdate);
  };

  onChangeValidationUpdate = (controls, isFormValid) => {
    this.props.updateStateAfterOnChangeValidation(controls, isFormValid);
  };
  
  saveValidationUpdate = (form, isFormValid, allValid) => {
    this.props.updateStateAfterOnSaveValidation(form, isFormValid, allValid);
  };

  afterSuccessSave = (message) => {
    this.props.updateStateAfterSuccessSave(message);
  };

  errorUpdate = (message, typeAlert) => {
    this.props.showErrorAlert(message, typeAlert);
  };

  render() {
    return <></>;
  };
}

export default PayoutTopUpComponent;